import React from "react";
import tw, { styled } from "twin.macro";
import "styled-components/macro";
import _ from "lodash";
import { getContrastText } from "../utils";
import { Link } from "gatsby";

const Container = styled.a`
  ${tw`bg-black hover:opacity-80  px-2 py-1 text-center text-xs sm:w-[100px] sm:mx-2 rounded block cursor-pointer`}
  background-color: ${(props) => props.color};
  color: ${(props) => getContrastText(props.color)};
`;

const LinkContainer = styled(Link)`
  ${tw`bg-black hover:opacity-80  px-2 py-1 text-center text-xs sm:w-[100px] sm:mx-2 rounded block cursor-pointer`}
  background-color: ${(props) => props.color};
  color: ${(props) => getContrastText(props.color)};
`;

const CompetitionChip = ({ competition, to }) => {
  const { name, color, link } = competition.node.frontmatter;

  if (to) {
    return (
      <LinkContainer color={color} to={to}>
        {name}
      </LinkContainer>
    );
  } else {
    return (
      <Container color={color} href={link} target="__blank">
        {name}
      </Container>
    );
  }
};

export default CompetitionChip;
